import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  selectCurrentUser,
  selectIsAuthenticated,
  selectAuthLoading,
  selectAuthInitialized,
} from "../../store/slices/authSlice";
import { CircularProgress, Box, CssBaseline } from "@mui/material";

const ProtectedRoute = ({ children, requiredRole }) => {
  const currentUser = useSelector(selectCurrentUser);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const loading = useSelector(selectAuthLoading);
  const isInitialized = useSelector(selectAuthInitialized);

  // Show loading while auth is initializing or loading
  if (!isInitialized || loading) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          backgroundColor: "#f5f5f5",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress size={60} sx={{ color: "#2196F3" }} />
      </Box>
    );
  }

  if (!isAuthenticated || !currentUser) {
    return <Navigate to="/login" />;
  }

  if (requiredRole && currentUser.role !== requiredRole) {
    return <Navigate to="/unauthorized" />;
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background:
          "linear-gradient(135deg, #f0f4f8 0%, #e1e8ed 50%, #e3f2fd 100%)",
      }}
    >
      <CssBaseline />
      {children}
    </Box>
  );
};

export default ProtectedRoute;
